









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { faClock } from "@fortawesome/free-regular-svg-icons"
import Typography from "@/components/Rain/Typography/Typography.vue"
import { formatSecondsToTimeLeft } from "@/utils/time";

@Component<CountDownTimer>({
    components: {
        Typography,
        FontAwesomeIcon
    }
})
export default class CountDownTimer extends Vue {
    @Prop({ type: Number, required: true })
    private readonly expires !: number // Countdown expiry in seconds

    private readonly faClock = faClock
    private secondsRemaining = this.expires

    public mounted() {
        this.countDown()
    }

    /**
     * Count Down - Removes a minute from the timer every 60 seconds.
     */
    public countDown() {
        if (this.secondsRemaining > 0) {
            setTimeout(() => {
                this.countDown()
                this.secondsRemaining -= 60
            }, 60000)
        }
    }

    public get timeRemaining(): string {
        return formatSecondsToTimeLeft(this.secondsRemaining)
    }

    /**
     * Returns true if there is only two hours left on the timer
     */
    public get twoHoursLeft(): boolean {
        return this.secondsRemaining < 7200 // 7200 seconds in 2 hours
    }
}
